import { useFirebaseObject } from "./useFirebaseObject";
import { ObjectType } from "./useObjectType";

export const objectTypeOptions: {
  label: string;
  value: ObjectType;
}[] = [
  {
    label: "Einfamilienhaus",
    value: "familyHome",
  },
  {
    label: "Mehrfamilienhaus",
    value: "apartmentHouse",
  },
  {
    label: "Strasse (Massenfotos)",
    value: "street",
  },
  {
    label: "Strasse (Detailfotos)",
    value: "streetWithDetailPhotos",
  },
];

export const useObject = (projectId: string, objectId: string) => {
  const [object, updateObject, isLoading] = useFirebaseObject(
    ["projects", projectId, "objects", objectId].join("/")
  );

  return { object, updateObject, isLoading };
};
